import { observer } from 'mobx-react';
import * as React from 'react';
import ModalStore from '../../../../Modal/Store';
import Form from '../../Edit/CurrentCollectionStep/Details/Form';
import LearningCollectionStore from '../../Store';
import { Building, NewFormSubmissionError } from '../../Types';
import BackButton from '../../LearningCollectionSteps/BackButton';
import ContinueButton from '../../LearningCollectionSteps/ContinueButton';
import Navigation from '../../Edit/CurrentCollectionStep/Navigation';
import ExeconlineCatalogDetails from './ExeconlineCatalogDetails';
import VideoProjectFeedbackDetails from './VideoProjectFeedbackDetails';
import { Maybe, nothing } from 'maybeasy';
import { FileMetaData } from '../../Edit/CurrentCollectionStep/Details/S3ImageUpload/Types';
import { UploadImageStore } from '../../Edit/CurrentCollectionStep/Details/UploadImageStore';
import { UploadImageState } from '../../Edit/CurrentCollectionStep/Details/UploadImageStore/Types';

interface Props {
  store: LearningCollectionStore;
  state: Building | NewFormSubmissionError;
}

class Builder extends React.Component<Props> {
  videoProjectFeedbackModalStore: ModalStore = new ModalStore();
  execonlineCatalogModalStore: ModalStore = new ModalStore();
  uploadImageStore = new UploadImageStore();

  constructor(props: Props) {
    super(props);
  }

  warnUser = () => this.props.store.browseAllCustomized;

  getFileMetaData = (state: UploadImageState): Maybe<FileMetaData> => {
    switch (state.kind) {
      case 'error':
      case 'loading':
        return nothing();
      case 'ready':
      case 'delete':
        return state.fileMetaData;
    }
  };

  render() {
    const { store } = this.props;

    return (
      <>
        <div>
          <Navigation store={this.props.store}>
            <BackButton handleOnClick={store.choosingProductLicense} />
            <ContinueButton
              handleOnClick={() => store.saving(this.getFileMetaData(this.uploadImageStore.state))}
              disabled={!store.canSave}
            />
          </Navigation>
          <div className="mx-auto max-w-clientPortalMaxWidth px-2.5 pb-4 pt-16 md:flex-row lg:px-12">
            <Form store={store} uploadImageStore={this.uploadImageStore} />
          </div>
        </div>
        <VideoProjectFeedbackDetails modalStore={this.videoProjectFeedbackModalStore} />
        <ExeconlineCatalogDetails modalStore={this.execonlineCatalogModalStore} />
      </>
    );
  }
}

export default observer(Builder);
